var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.667 54h5.39C72.873 54 85 41.85 85 27S72.875 0 58.056 0H0l6.222 10.8h51.834c8.89 0 16.166 7.29 16.166 16.2 0 8.909-7.274 16.2-16.166 16.2h-5.389V54zM12.445 21.6l6.222 10.8h12.445V54H41.89V32.4h21.555V21.6h-51z",
    fill: "#2E5ECC"
  })));
}

export default SvgLogoAbout;